import _ from 'lodash';

export const isValidString = (value) => {
  // Was the value set
  if (!value) {
    return false;
  }

  // Is the value just empty space?
  if (value.trim && !value.trim()) {
    return false;
  }

  return true;
};

export const normalizeStringLength = maxLength => (value, previousValue) => {
  if (_.isUndefined(value)) {
    return previousValue;
  }

  return _.truncate(value, { length: maxLength, omission: '' });
};
